import type { SiteLanguage } from "@/lib/language";

type OtherLanguage = Exclude<SiteLanguage, "ru">;

/**
 * One translation namespace. Russian is the master set: every other language must provide exactly the same
 * keys (missing or extra keys fail typecheck). Keys are prefixed with the namespace (`"auth.title"`), so
 * namespaces can never shadow each other when they are merged.
 *
 * Values support `{name}` interpolation. A plural message lists CLDR categories separated by `|`, e.g.
 * `"one:{count} предмет|few:{count} предмета|many:{count} предметов|other:{count} предмета"`.
 */
export function defineMessages<const T extends Record<string, string>>(messages: { ru: T } & { [L in OtherLanguage]: { [K in keyof T]: string } }) {
  return messages;
}
